/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-b011b919.mjs';
import { defineComponent, inject, createVNode } from 'vue';
import TimeLineItemProps from './time-line-item-props.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { useContent, useTNodeJSX } from '../hooks/tnode.mjs';
import { TimelineInjectKey, DEFAULT_PROVIDER } from './hooks.mjs';
import { Loading } from '../loading/index.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-7f2f03b4.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';
import '../_chunks/dep-f50ac97c.mjs';
import '../_chunks/dep-94585de3.mjs';
import '../_chunks/dep-06221fe2.mjs';
import '../_chunks/dep-d7053a2c.mjs';
import '../_chunks/dep-f3e3393e.mjs';
import '../_chunks/dep-0fa7026c.mjs';
import '../_chunks/dep-31dc9d09.mjs';
import '../_chunks/dep-b9d74a58.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ff1c0573.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../_chunks/dep-fc63c737.mjs';
import '../_chunks/dep-2a2a0e63.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/set-style.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-56ceb7ce.mjs';
import '../_chunks/dep-c3626417.mjs';
import '../_chunks/dep-e00db566.mjs';
import '../_chunks/dep-fdde96c5.mjs';
import '../_chunks/dep-961339ce.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../loading/props.mjs';
import '../hooks/useTeleport.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../loading/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DEFAULT_THEME = ["default", "primary", "success", "warning", "error"];
var _TimelineItem = defineComponent({
  name: "TTimelineItem",
  props: _objectSpread(_objectSpread({}, TimeLineItemProps), {}, {
    index: {
      type: Number
    }
  }),
  setup: function setup(props) {
    var COMPONENT_NAME = usePrefixClass("timeline-item");
    var TimelineProvider = inject(TimelineInjectKey, DEFAULT_PROVIDER);
    var renderContent = useContent();
    var renderTNodeJSX = useTNodeJSX();
    var getPositionClassName = function getPositionClassName(index) {
      var _props$labelAlign;
      var _TimelineProvider$val = TimelineProvider.value,
        layout = _TimelineProvider$val.layout,
        renderAlign = _TimelineProvider$val.renderAlign;
      var timelineItemAlign = (_props$labelAlign = props.labelAlign) !== null && _props$labelAlign !== void 0 ? _props$labelAlign : renderAlign;
      var left = layout === "horizontal" ? "top" : "left";
      var right = layout === "horizontal" ? "bottom" : "right";
      if (timelineItemAlign === "alternate") {
        return index % 2 === 0 ? "".concat(COMPONENT_NAME.value, "-").concat(left) : "".concat(COMPONENT_NAME.value, "-").concat(right);
      }
      if (timelineItemAlign === "left" || timelineItemAlign === "top") {
        return "".concat(COMPONENT_NAME.value, "-").concat(left);
      }
      if (timelineItemAlign === "right" || timelineItemAlign === "bottom") {
        return "".concat(COMPONENT_NAME.value, "-").concat(right);
      }
      return "";
    };
    return function () {
      var _ref, _ref2;
      var _TimelineProvider$val2 = TimelineProvider.value,
        mode = _TimelineProvider$val2.mode,
        theme = _TimelineProvider$val2.theme,
        itemsStatus = _TimelineProvider$val2.itemsStatus,
        reverse = _TimelineProvider$val2.reverse;
      var loading = props.loading,
        dotColor = props.dotColor,
        index = props.index;
      var labelNode = renderTNodeJSX("label");
      var dotElement = renderTNodeJSX("dot");
      var dotContentClass = "".concat(COMPONENT_NAME.value, "__dot-content");
      if (dotElement !== null && dotElement !== void 0 && dotElement.props) {
        var _dotElement$props;
        var classes = dotElement === null || dotElement === void 0 ? void 0 : (_dotElement$props = dotElement.props) === null || _dotElement$props === void 0 ? void 0 : _dotElement$props["class"];
        dotElement.props["class"] = classes ? [dotContentClass, classes].join(" ") : dotContentClass;
      }
      return createVNode("li", {
        "class": ["".concat(COMPONENT_NAME.value), "".concat(getPositionClassName(props.index))]
      }, [mode === "alternate" && labelNode && createVNode("div", {
        "class": ["".concat(COMPONENT_NAME.value, "__label"), "".concat(COMPONENT_NAME.value, "__label--").concat(mode)]
      }, [labelNode]), createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__wrapper")
      }, [createVNode("div", {
        "class": (_ref = {}, _defineProperty(_ref, "".concat(COMPONENT_NAME.value, "__dot"), true), _defineProperty(_ref, "".concat(COMPONENT_NAME.value, "__dot--custom"), !!dotElement || !dotElement && loading), _defineProperty(_ref, "".concat(COMPONENT_NAME.value, "__dot--").concat(dotColor), DEFAULT_THEME.includes(dotColor)), _ref),
        "style": {
          borderColor: !DEFAULT_THEME.includes(dotColor) && dotColor
        }
      }, [!dotElement && loading && createVNode(Loading, {
        "size": "12px",
        "class": dotContentClass
      }, null), dotElement]), createVNode("div", {
        "class": (_ref2 = {}, _defineProperty(_ref2, "".concat(COMPONENT_NAME.value, "__tail"), true), _defineProperty(_ref2, "".concat(COMPONENT_NAME.value, "__tail--theme-").concat(theme), true), _defineProperty(_ref2, "".concat(COMPONENT_NAME.value, "__tail--status-").concat(itemsStatus[index]), reverse), _ref2)
      }, null)]), createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__content")
      }, [renderContent("default", "content"), mode === "same" && labelNode && createVNode("div", {
        "class": ["".concat(COMPONENT_NAME.value, "__label"), "".concat(COMPONENT_NAME.value, "__label--").concat(mode)]
      }, [labelNode])])]);
    };
  }
});

export { _TimelineItem as default };
//# sourceMappingURL=timeline-item.mjs.map
